/**
 * Returns link with replaced params
 * @param base string
 * @param params object
 * @return string
 */
const getLinkWithParams = (base: string, params: object = {}): string => {
  let result = base

  Object.keys(params).forEach((param) => {
    result = result.replace(new RegExp(`:${param}`, 'g'), params[param])
  })

  return result
}

export default getLinkWithParams
